module.exports = __webpack_public_path__ + "img/step50_b_printer_basic_remove_retainers_close_roll_cover.dd7bb254.png";